import React from "react";
import { Card, Column, Text, Row, Icon } from "@amzn/meridian";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  return (
    <Column>
      <Card
        spacingInset="200 400"
        onClick={() => {
          navigate("/configurationDrivenInspections")
        }}
      >
        <Row alignmentHorizontal="justify" height={64}>
          <Column spacing="200">
            <Row>
              <Text type="b300">Safety Inspection</Text>
            </Row>
          </Column>
          <Icon tokens={chevronRightSmallTokens} />
        </Row>
      </Card>
    </Column>
  );
};

export default Home;
